<ng-container *ngIf="ssoConfig$ | async as config">
  <ng-container *ngIf="config.isLoading">
    <spinner></spinner>
  </ng-container>
  <!-- update with grid system - remove the static css -->

  <div *ngFor="let link of config.ssoLinks" class="container">
    <div [ngSwitch]="link.code">
      <div *ngSwitchCase="'connect'">
        <a (click)="navigateToSecoPage()">
          <ng-container *ngTemplateOutlet="linkItem; context: { link: link }"></ng-container>
        </a>
      </div>
      <div *ngSwitchCase="ssoPages.EDENRED_SUPPORT">
        <a
          (click)="navigateToEdenredSupportPage()"
          *ngIf="isEdenredADSupportFlowEnabled && isCountryEnabledWithPlusMe && isCountryEnabledWithEdenred"
        >
          <ng-container *ngTemplateOutlet="linkItem; context: { link: link }"></ng-container>
        </a>
      </div>
      <div *ngSwitchCase="ssoPages.PLUSME_SUPPORT">
        <a (click)="navigateToAdSupportPage(link)" *ngIf="isEdenredADSupportFlowEnabled && isCountryEnabledWithPlusMe">
          <ng-container *ngTemplateOutlet="linkItem; context: { link: link }"> </ng-container>
        </a>
      </div>
      <div *ngSwitchDefault>
        <a (click)="navigateBySSOLink(link)">
          <ng-container *ngTemplateOutlet="linkItem; context: { link: link }"></ng-container>
        </a>
      </div>
    </div>
  </div>
</ng-container>
<svg *ngIf="'m' === type" class="sso-tile__background-icon">
  <use href="/assets/images/svg_ico/icons.svg#sso_tile_backgound"></use>
</svg>
<ng-template #linkItem let-link="link">
  <div class="row mb-5 pb-3 d-flex align-items-center">
    <div class="col-3 text-center">
      <span
        class="display-5 external-link"
        [ngClass]="{
          'fa-mouse': link.code === ssoPages.SERVICE_HUB,
          'fa-browser': link.code === ssoPages.SELL_CONNECT,
          'fa-users': link.code === ssoPages.COMMUNITY,
          'fa-gift': link.code === ssoPages.EDENRED_SUPPORT,
          'fa-circle-question': link.code === ssoPages.PLUSME_SUPPORT
        }"
      ></span>
    </div>
    <div class="col">
      <span class="external-link">{{ link.title }}</span>
      <span class="fa-arrow-up-right-from-square df-icon-wtd mx-2 external-link"></span>
    </div>
  </div>
</ng-template>
